import Cookies from 'universal-cookie'
import { LEXNET_COOKIE_NAME, LEXNET_COOKIE_TIMEOUT } from 'src/config'

export type LexnetCookieValue = {
  expirationTime: string
  userText: string
}

export default function useCookie(): any {
  function addLexnetCookie(userText: string) {
    const cookies = new Cookies()
    const expire: Date = new Date()
    expire.setMinutes(expire.getMinutes() + LEXNET_COOKIE_TIMEOUT)
    const expirationTime = btoa(JSON.stringify(expire))
    const cookieValue: LexnetCookieValue = {
      expirationTime,
      userText
    }

    cookies.set(LEXNET_COOKIE_NAME, cookieValue, { expires: expire, path: '/' })
  }

  function existLexnetCookie(): boolean {
    const cookies = new Cookies()

    if (!cookies.get(LEXNET_COOKIE_NAME)) {
      return false
    }

    const currentDate: Date = new Date()
    const expirationDate: Date = new Date(
      JSON.parse(atob(cookies.get(LEXNET_COOKIE_NAME)?.expirationTime))
    )

    return expirationDate > currentDate
  }

  function getLexnetCookieValue(): LexnetCookieValue | undefined {
    const cookies = new Cookies()
    const cookieValue: LexnetCookieValue | undefined = cookies.get(LEXNET_COOKIE_NAME)
    return cookieValue
  }

  function getLexnetCookieExpirationValue(): Date | undefined {
    const cookieValue: LexnetCookieValue | undefined = getLexnetCookieValue()
    if (cookieValue !== undefined) {
      const { expirationTime } = cookieValue
      return JSON.parse(atob(expirationTime))
    }
    return cookieValue
  }

  function getLexnetCookieUserText(): string | undefined {
    const cookieValue: LexnetCookieValue | undefined = getLexnetCookieValue()
    if (cookieValue !== undefined) {
      const { userText } = cookieValue
      return userText
    }
    return cookieValue
  }

  function removeLexnetCookie() {
    const cookies = new Cookies()
    cookies.remove(LEXNET_COOKIE_NAME, { path: '/' })
  }

  return {
    addLexnetCookie,
    existLexnetCookie,
    getLexnetCookieExpirationValue,
    getLexnetCookieUserText,
    removeLexnetCookie
  }
}
